import swal from "sweetalert";
import { useState } from "react";
import FormCargos from "../components/form-cargos";
import useUser from "../../../../core/hooks/use-user";
import useModal from "../../../../core/hooks/use-modal";
import { toast } from "../../../../core/helpers/message-helper";
import Datatable from "../../../../core/ui/components/Datatable";
import { sweetAl } from "../../../../core/helpers/message-helper";
import { API_URL } from "../../../../core/config/env";
import { activarCargo, inactivarCargo } from "../../services/cargos-service";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";

const Cargos = () => {
    const { getAccessToken, userCan } = useUser();
    const token = getAccessToken();
    const [dtInstance, onDtInstance] = useState({});

    const modalCargos = useModal({
        title: "Agregar Cargo",
        data: { cargo: {} },
    });

    const getDtInstance = (dt) => onDtInstance(dt);

    const onSave = () => {
        dtInstance.ajax.reload();
    };

    let tableButtons = [];

    if (userCan("cargosCrear")) {
        tableButtons.push({
            titleAttr: "Agregar Cargo",
            text: '<i class="fas fa-plus"></i>',
            action: function () {
                modalCargos.open({
                    title: "Agregar Cargo",
                    data: { cargo: {} },
                });
            },
            className: "btn btn-sm btn-secondary",
        });
    }

    if (userCan("cargosEditar")) {
        tableButtons.push({
            titleAttr: "Editar Cargo",
            text: '<i class="fas fa-pen"></i>',
            action: async (_, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                modalCargos.open({
                    title: "Editar Cargo",
                    data: { cargo: data },
                });
            },
            className: "btn btn-sm btn-grey",
        });
    }

    if (userCan("cargosInactivar")) {
        tableButtons.push({
            titleAttr: "Inactivar Cargo",
            text: '<i class="fas fa-trash"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea inactivar este Cargo?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        eliminar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning("No se ha inactivado el Cargo");
                        break;
                    case "eliminar": {
                        const resp = await inactivarCargo(data.id);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al inactivar el Cargo"
                            );
                        }

                        sweetAl.success("El Cargo fue inactivado correctamente");
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-danger",
        });
    }

    if (userCan("cargosActivar")) {
        tableButtons.push({
            titleAttr: "Activar Cargo",
            text: '<i class="fas fa-check"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea activar este Cargo?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        activar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning("No se ha activado el Cargo");
                        break;
                    case "activar": {
                        const resp = await activarCargo(data);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al activar el Cargo"
                            );
                        }

                        sweetAl.success("El Cargo fue activado correctamente");
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-primary",
        });
    }

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "cargos",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ]

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tablaCargos",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/administrar/cargos`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error al obtener el listado de los cargos"
                );
            },
        },
        columns: [{ data: "id" },
        { data: "nombre" },
        { data: "nombre_tipo_cargo" },
        { data: "status" }],
        columnDefs: [
            {
                targets: 3,
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 1 ? "Activo" : "Inactivo";
                    td.classList.add(
                        cellData == 1 ? "text-success" : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    ADMINISTRAR / Cargos
                </div>
            </div>
            <Datatable options={dtOptions} dtInstance={getDtInstance}>
                <table
                    className="w-100 table table-hover"
                    id="tablaCargos"
                >
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Nombre</th>
                            <th>Tipo Cargo</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
            <FormCargos modalState={modalCargos} onSave={onSave} />
        </ContentWrapper>
    );
};

export default Cargos;
